// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"26d2c200","390":"48bd51d2","491":"fac9fae3","552":"1f6dda30","588":"d0511df7","719":"7e8d2c07","903":"d325a112","955":"fed9fe65","988":"83e0e8a7"}[chunkId] + ".chunk.js";
};